import { NFIdentity, TagCategory } from '@nibras/core/common';
import { DataStoreOptions } from './data-store-options';

export class dcTag {
  constructor(
    public TagID?: number,
    public TagName?: string,
    public ElementTypeID?: NFIdentity,
    public SourceObjectID?: number,
    public ObjectID?: number,
    public IsLazyLoading = false,
    public IsShallowsearch = false,
    public isSelected = false,
    public contextObject?: any,
    public dataStoreOptions: DataStoreOptions = new DataStoreOptions(),
    public dataStoreKey?: string,
    public isRemovable = true,
    public CategoryID: TagCategory = TagCategory.Unknown,
    public ActiveOn?: Date,
    public InActiveOn?: Date,
    public ObjectName?: string,
    public ObjectClassID?: number,
    public SourceClassID?: number,
    public Level?: number,
    public IsWildCard = false,
    public IsDeleted = false,
    // UI specific property
    public isDisabled = false
  ) {
    //for client side. //for client side. //for client side?
    if (this.ObjectID) this.dataStoreKey = this.ObjectID.toString();
  }
}
